module.exports = __webpack_public_path__ + "static/media/main_hello_ic.3653c257.png";